module.exports = __webpack_public_path__ + "static/img/statistics_overview.c5590f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/statistics_overview.svg
// module id = OD/b
// module chunks = 1